<template>
  <div :merchant="config.merchant" id="minidelivery">
    <div class="loading-container" :class="{hidden: states.ready}"> <div class="lds-facebook"> <div></div><div></div><div></div></div></div>
    <component 
      :class=" {hidden: ((!states.ready) || (states.failed)) }"
      :is="page" 
      :menulist="this.menulist" 
      :cart="normalizedCart"
      :shops="shops"
      :shop="shop"
      :validcart="validcart"
      :invoice="invoice"
      :merchant="merchant"
      :invoicedata="invoicedata"
      :api="api"
      :merchant_hash="config.merchant"
      @validcart="e => validcart = e"
      @portion="portion"
      @order="applyOrder" 
      @guest="applyGuest"
      @back="OnBack"
      @readyState="globalReady"
      @errorState="globalError"
      @shopselect="shopSelect"
      @performInvoice="performInvoice"
      @goto="fastgo"
      >
    </component>
    
    <ErrorPlaceholder :class="{hidden: !states.failed}" :message="states.error"/>
    <CarbisFooter :class="{hidden: states.failed}"/>
  </div>
</template>

<script>
import MenuPage from './components/MenuPage'
import ShopList from './components/ShopList'
import DeliveryApi from './minideliveryapi.js'
import ErrorPlaceholder from './components/ErrorPlaceholder'
import ValidateOrder from './components/ValidateOrder'
import GuestForm from './components/GuestForm'
import InvoiceResult from './components/InvoiceResult'
import CarbisFooter from './components/CarbisFooter'
//import ItemPopup from './components/ItemPopup'

export default {
  name: 'Minidelivery',
  data (){
    return {
     config:{
        merchant:'',
        // url:'http://192.168.1.7:5000/shopapi'
        url:'https://dev.carbis.ru/shopapi'
        // url:'http://109.202.22.231:8934/shopapi'
      },
      states:{
        ready: false,
        failed: false,
        error: ''
      },
      api: undefined,
      shop: {},
      merchant:{},
      invoice:{},
      invoicedata:{},
      validcart:{},
      page: 'shop-list',
      shops:[],
      menulist: [],
      cart: []
    }
  },
  methods:{
    portion(portion){
      this.cart.push(portion)
    },
    getQuery(){
      let query = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, pair) => {
          const [key, value] = pair.map(decodeURIComponent);
          return ({ ...obj, [key]: value })
      }, {})
      let params = undefined
      
      if (query.minidlv) {
          let str = decodeURIComponent(escape(atob(query.minidlv)))
          params = JSON.parse(str)
      }
      return params
    },
    applyOrder: async function (data){
      let orderType
      let delivery_zone
      let was_undefined
      if (data == undefined) {
        was_undefined = true
        orderType = this.shop.allowdlv ? 1 : this.shop.allowta ? 0 : -1
        if (orderType == -1) {
          this.$raise('Нет доступных типов заказа.')
          this.OnBack()
          return 0
        }

        delivery_zone = undefined
      } else {
        was_undefined = false
        orderType = data.OrderType
        delivery_zone = data.delivery_zone
      }
      
      try {
        let data = await this.api.validate({cart:this.normalizedCart, ordertype: orderType, delivery_zone:delivery_zone})

        this.validcart = data.data
        this.validcart.canorder = this.validcart.canorder && !was_undefined
        this.gotoPage('validate-order')
        this.globalReady()

      } catch (err) {
        this.$raise(err)
        this.OnBack()
      }
    },
    applyGuest: function (){
      this.gotoPage('guest-form')
    },
    shopSelect: function(shop){
      this.shop = shop
      this.api = new DeliveryApi(shop.id, this.config.url)
      this.gotoPage('menu-page')
      sessionStorage.setItem('minideliveryshopid', shop.id)
      this.api.getmenu()
        .then((data) => {
          this.menulist = data.data
          if (sessionStorage.getItem('minideliverycart')) {
            this.cart = JSON.parse(sessionStorage.getItem('minideliverycart'))
          }
          this.globalReady()
        })
        .catch((err) => {
          sessionStorage.removeItem('minideliveryshopid')
          this.$raise(err)
          this.OnBack()
        })
    },
    globalError: function (text) {
      this.states.failed = true
      this.states.error = text
      this.states.ready = true
    },
    globalReady: function(){
      this.states.ready = true
      this.states.failed = false
    },
    gotoPage: function (page) {
      this.states.failed = false
      this.states.error = ''
      this.states.ready = false
      this.page = page
    },
    async fastgo(page){
      if (page == 'validate-order'){
        await this.applyOrder()
        return 0
      } else {
        this.page = page
      }
    },
    OnBack: function() {
      if (this.page == 'validate-order') {
        this.gotoPage('menu-page')
      } else if (this.page == 'guest-form'){
        this.gotoPage('menu-page')
      } else if (this.page == 'menu-page') {
        sessionStorage.removeItem('minideliveryshopid')
        sessionStorage.removeItem('minideliverycart')
        this.gotoPage('shop-list')
      } else if (this.page == 'invoice-result') {
        this.gotoPage('validate-order')
      }
      this.globalReady()
    },
    performInvoice(guestData){
      this.gotoPage('invoice-result')
      
      guestData.fromurl = window.location.href

      this.api.invoice(guestData)
        .then( data => {
          sessionStorage.setItem('minideliveryinvoice', data.invid)
          this.invoice = data.invid
          if (data.goto.action == 'error') {
            this.$raise(data.goto.payload)
            this.OnBack()
          } else if (data.goto.action == 'success') {
            this.checkInvoiceResult(data.invid)
          } else if (data.goto.action == 'url') {
            //window.location.replace(data.goto.payload)
            
            if (data.goto.payload.redirect_url){
              window.location.href = data.goto.payload.redirect_url
              return 0
            }

            let postform = document.createElement('form')
            postform.action = data.goto.payload.url
            postform.method = 'POST'
            for (let [k,v] of Object.entries(data.goto.payload))
            {
              if (k == 'url') continue
              let inp = document.createElement('input')
              inp.type = 'hidden'
              inp.name = k
              inp.value = v
              postform.appendChild(inp)
            }
            document.body.appendChild(postform)
            postform.submit()
          }
        })
        .catch( err => {
          this.$raise(err)
          this.OnBack()
        })
    },
    checkInvoiceResult(invcrc){
      this.states.reload = false
      this.api.status({crc: invcrc})
        .then(data => {
          this.invoicedata = data.data
          this.invoicedata.crc = invcrc
          this.globalReady()
        })
        .catch(err=>{
          this.$raise(err, ()=>{
            sessionStorage.removeItem('minideliveryshopid')
            sessionStorage.removeItem('minideliverycart')
            sessionStorage.removeItem('minideliveryinvoice')
            window.location.reload()
          })

        })
    }
  },
  computed:{
    normalizedCart(){
      return this.cart.filter( item => item.qty > 0)
    }
    /*cart: function () {
        let res = []
        for (let line of Object.entries(this.menulist)) {
            Array.prototype.push.apply(res, line[1].filter(item => item.qty > 0)) 
        }
        return res
    }*/
  },
  watch:{
    cart: function (val){
      if (val != '') sessionStorage.setItem('minideliverycart', JSON.stringify(val))
    }      
  },
  async beforeMount(){
    this.error = false
    this.ready = false
    this.config.merchant = document.getElementById('minidelivery').getAttribute('merchant')
  },
  async mounted(){
    try {
      let response = await fetch(this.config.url+'/v1/getshops', {headers:{merchant: this.config.merchant}})
      let data = await response.json()
      if (data.result == false) {
        this.globalError(data.msg)
      } else {
        this.merchant = data.data.merchant
        this.shops = data.data.shops
        let params = this.getQuery()
        if (params && params.invokeInvoice && !sessionStorage.getItem('minideliverycart') && !sessionStorage.getItem('minideliveryshopid')){
          try{
            let invoice = await fetch(this.config.url+'/v1/invokeinvoice?invcrc='+params.invokeInvoice, {headers:{merchant: this.config.merchant}})
            let data = await invoice.json()
            if (data.result == true){
              let a = this.shops.filter(shop => (shop.id == data.data.shopid) && (shop.online == true))
              if (a.length == 0) {
                this.$raise('К сожалению ресторан, в котором Вы делели заказ, сейчас не работает')
              } else {
                sessionStorage.setItem('minideliverycart', JSON.stringify(data.data.cart))
                this.shopSelect(a[0])
                return 0
              }
            } else {
              console.log('Invoke error: '+data.msg)
              this.$raise('К сожалению повторить Ваш заказ невозможно')
            }
          }catch { err => {
            console.log('Invoke error: '+err)
            this.$raise('К сожалению повторить Ваш заказ невозможно')
          }}
        }
        if (this.shops.length == 1){
          if (sessionStorage.getItem('minideliveryshopid')){
            if (sessionStorage.getItem('minideliveryshopid') != this.shops[0].id)
              sessionStorage.removeItem('minideliverycart')
          }
          if (this.shops[0].online == true) {
            this.shopSelect(this.shops[0])
          } else {
            this.globalReady()
          }
        } else if (this.shops.length == 0) {
          this.globalError('Нет доступных ресторанов. Пожалуйста, попробуйте позже.')
          sessionStorage.removeItem('minideliveryshopid')
        }
        else {
          if (sessionStorage.getItem('minideliveryshopid')){
            let a = this.shops.filter(s => {
              if (s.id == sessionStorage.getItem('minideliveryshopid')) {
                if (s.online == true) {
                  this.shopSelect(s)
                  return true
                }
              }
            })
            if (a.length == 0) {
              this.globalReady()
              sessionStorage.removeItem('minideliveryshopid')
              sessionStorage.removeItem('minideliverycart')
            }
          } else this.globalReady()
        }
      }
    } catch (err) {
      console.log('Shops failed. '+err.message)
      this.globalError('Онлайн-заказ невозможен. Повторите попытку позднее.')
    }
    if (sessionStorage.getItem('minideliveryinvoice')){
      this.gotoPage('invoice-result')
      this.checkInvoiceResult(sessionStorage.getItem('minideliveryinvoice'))
    }
  },
  components: {
    MenuPage,
    ErrorPlaceholder,
    ValidateOrder,
    GuestForm,
    ShopList,
    InvoiceResult,
    CarbisFooter,
    //ItemPopup
  }
}
</script>